import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ProdDialogData, ProdDialogService} from "prod-dialog";
import {MatListOption} from "@angular/material/list";
import {Subject, take} from "rxjs";
import {GridFilterEvent} from "prod-shared";
import {ClientFilter} from "../model/client-filter";
import {DipClientFilterService} from "../service/dip-client-filter.service";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../role";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'prod-grid-filter-save-dialog',
  templateUrl: './dip-grid-filter-dialog.html',
  styleUrls: ['./dip-grid-filter-dialog.scss']
})
export class DipGridFilterDialog implements OnInit {
  title: string = this.translate.instant('grid_filter.main_title');
  formTitle: string = this.translate.instant('grid_filter.form_title');
  privateFiltersTitle: string = this.translate.instant('grid_filter.private_filters');
  publicFiltersTitle: string = this.translate.instant('grid_filter.public_filters');
  clientFilters: ClientFilter[] = [];
  canDeletePublicFilter = this.roleService.hasRole([Role.ROLE_CLIENT_FILTER_DELETE]);
  deletedFilters$: Subject<number> = new Subject<number>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
    private clientFilterService: DipClientFilterService,
    private roleService: RoleService,
    private dialogService: ProdDialogService,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.clientFilters = this.dialogData.data.clientFilters;
    this.dialogData.data.filterEvents.subscribe(event => {
      if (event.name === GridFilterEvent.LOAD) this.clientFilters = event.value;
    })
  }

  deleteFilters(selectedOptions: MatListOption[]): void {
    this.dialogService.confirm(this.translate.instant('grid_filter.confirm_delete')).subscribe(confirmed => {
      if (confirmed) {
        selectedOptions.forEach(option => {
          this.clientFilterService.delete(option.value).pipe(take(1)).subscribe(() => {
            this.clientFilters = this.clientFilters.filter(f => f.id !== option.value);
            this.deletedFilters$.next(option.value);
          });
        });
      }
    });
  }

  filterList(isPrivate: boolean) {
    return this.clientFilters.filter(f => !!f.user === isPrivate)
  }
}
